import {api, defineCancelApiObject} from "./config"
import {APIs, getAPIToken} from "../api/services";

export const GeocoderAPI = {
    isValidZipCode: async function (country, zipCode, cancel = false) {
        const token = await getAPIToken(APIs.connectAPI) //todo change per API
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        }
        const response = await api.request({
            url: `/api/v1/rpc/geocode/${country}/${zipCode}`,
            method: "GET",
            headers: headers,
            signal: cancel ? cancelApiObject[this.get.code].handleRequestCancellation().signal : undefined,
        }).catch((e) => {
            //
            return false
        })
        return response.status === 200
    }
}

const cancelApiObject = defineCancelApiObject(GeocoderAPI)